function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.12,
  cx: 12,
  cy: 12,
  r: 10,
  fill: "#D8DAE7"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 10.5V10a2 2 0 114 0v.121c0 .563-.223 1.102-.621 1.5L12 13m.5 3a.5.5 0 01-1 0m1 0a.5.5 0 00-1 0m1 0h-1M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
});

var SvgQuestionmarkOutlined = function SvgQuestionmarkOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    stroke: "#D8DAE7"
  }, props), _ref, _ref2);
};

export default SvgQuestionmarkOutlined;